import React from 'react'
import styled from 'styled-components'
import { convertNodeToElement } from 'react-html-parser'
import inlineStyleToObject from 'react-html-parser/lib/utils/inlineStyleToObject'
import { ARTICLE_PREVIEW_NAME, ArticlePreviewIframe } from '../../article-preview'
import { COMMODITY_LINK_NAME, CommodityLinkIframe } from '../../commodity-link'
import { StyledArticleContent } from '../WebPost.styled'
import { TableOfContents, TABLE_OF_CONTENTS_NAME } from '@features/post/table-of-content'

const Container = styled(StyledArticleContent)`
  padding: 0 20px;

  amp-instagram {
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px solid rgb(219, 219, 219);
    display: block;
    margin: 10px 0px 5px;
  }

  amp-img {
    margin: 10px 0;
  }

  .article-preview {
    amp-iframe {
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      overflow: hidden;
      pointer-events: none;

      iframe {
        margin: 0;
      }
    }
  }
`

const transform = (node, index, post) => {
  const { name, attribs } = node
  const style = inlineStyleToObject(attribs?.style)

  if (name === 'ad') {
    return null
  }

  if (name === 'img') {
    // srcset sizes 會造成跑版
    const { width = 1, height = 1, src, alt } = attribs

    return (
      <amp-img
        src={src}
        key={index}
        style={style}
        layout="responsive"
        width={width}
        height={height}
        alt={alt}
      />
    )
  }

  if (name === 'instagram') {
    const { shortCode } = attribs

    return (
      <amp-instagram
        key={index}
        width="1"
        height="1"
        layout="responsive"
        data-shortcode={shortCode}
      />
    )
  }

  if (name === 'iframe') {
    return (
      <amp-iframe
        {...attribs}
        key={index}
        style={style}
        layout="responsive"
        sandbox="allow-scripts allow-same-origin allow-popups"
      />
    )
  }

  if (name === 'video') {
    return (
      <amp-video {...attribs} key={index} style={style} layout="responsive">
        {node.children.filter((child) => child.name == 'source').map(transform)}
      </amp-video>
    )
  }

  if (name === ARTICLE_PREVIEW_NAME) return <ArticlePreviewIframe key={index} {...attribs} />
  if (name === COMMODITY_LINK_NAME) return <CommodityLinkIframe key={index} {...attribs} />
  if (name === TABLE_OF_CONTENTS_NAME)
    return <TableOfContents key={index} {...attribs} clas={post?.clas} postID={post?.postID} isAmp={true} />

  return convertNodeToElement(node, index, transform)
}

type Props = {
  nodes: any[]
  post?: any
}

function Article(props: Props) {
  const { nodes, post } = props
  const children = nodes.map((node, index) => transform(node, index, post))

  return <Container>{children}</Container>
}

export default Article
